import React from 'react';

const Loader = () => {

    return (
        <div className="contenido">
            <div className="spinner">
            </div>
            <i className="bi bi-camera-fill" />
        </div>
    );
};

export default Loader;
